"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderHeart: function() {
        return FolderHeart;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderHeart = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 5C1 3.89543 1.89543 3 3 3H9C9.19742 3 9.39043 3.05844 9.5547 3.16795L12.3028 5H21C22.1046 5 23 5.89543 23 7V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM8.69722 5H3V19H21V7H12C11.8026 7 11.6096 6.94156 11.4453 6.83205L8.69722 5ZM11.997 9.43295C10.9974 8.83944 9.68367 8.7979 8.62297 9.66103C7.32953 10.7135 7.11986 12.5349 8.16768 13.819C8.52969 14.2627 9.69759 15.5145 10.5462 16.4166C11.3347 17.2548 12.666 17.2541 13.4537 16.4153C14.3009 15.513 15.4661 14.262 15.8275 13.819C16.8659 12.5465 16.6948 10.7078 15.3617 9.65259C14.2966 8.80951 12.9947 8.84021 11.997 9.43295ZM11.2536 11.3801C10.8531 10.9342 10.2851 10.887 9.88531 11.2123C9.42522 11.5867 9.38802 12.1511 9.71726 12.5546C10.022 12.928 11.1217 14.1094 11.9993 15.0424C12.8751 14.1096 13.973 12.9283 14.2779 12.5546C14.6166 12.1395 14.571 11.5774 14.1204 11.2208C13.695 10.884 13.1348 10.9423 12.7416 11.3801C12.5519 11.5913 12.2814 11.7119 11.9976 11.7119C11.7138 11.7119 11.4433 11.5913 11.2536 11.3801Z",
        fill: "currentColor"
    })
}), "FolderHeart");
const _default = FolderHeart;
